export default {"src":"/_next/static/media/red-alerts-badge.1f452fdf.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};